/* eslint-disable no-param-reassign */
import _ from 'underscore';
import * as putil from '@bingads-webui-universal/primitive-utilities';
import { FilterEntity } from '@bingads-webui/filter-entity';

function isNullQuery(query) {
  return query && _.values(query) && _.isEqual(_.values(query)[0], {
    $in: null,
  });
}

function mergeQuery(baseQuery, addedQuery) {
  let newQuery;


  if (addedQuery.$and && addedQuery.$and.length > 0) {
    addedQuery.$and = _.filter(addedQuery.$and, query => !isNullQuery(query));
  } else {
    addedQuery = isNullQuery(addedQuery) ? {} : addedQuery;
  }

  if (_.isUndefined(baseQuery) || _.isEmpty(baseQuery)) {
    newQuery = addedQuery;
  } else {
    if (_.isUndefined(addedQuery)) {
      newQuery = {};
    } else {
      newQuery = putil.cloneDeep(addedQuery);
    }

    if (_.isEmpty(newQuery)) {
      newQuery = baseQuery;
    } else if (_.has(newQuery, '$and')) {
      const and = _.union(newQuery.$and, [baseQuery]);

      newQuery.$and = and;
    } else {
      newQuery = {
        $and: [baseQuery, addedQuery],
      };
    }
  }
  return newQuery;
}

function mergeFilterEntity(entities, options) {
  if (_.isArray(entities) && !_.isEmpty(entities)) {
    const newQuery = _.reduce(
      entities,
      (memo, entity) => mergeQuery(memo, entity.query), undefined
    );

    return new FilterEntity(newQuery, options);
  }
  return {};
}

export { mergeFilterEntity };
